import React, { Fragment, useState, useEffect } from "react";
export const WizardStyle = ((props: any) => {
    const { key, label, value, open } = props;
    return (
        <div style={{ padding: '0px 5px' }}>
            <label style={{ fontWeight: 700, fontSize: "11px", color: "#282B31", marginTop: "2px" }}>
                Wizard Styles
            </label>
            <div className="grid grid-cols-5 formWizardStyle" style={{ backgroundColor: '#D9D9D9', border: '4px solid #D9D9D9', borderRadius: '4px' }}>
                <div style={{ backgroundColor: value?.color1 ? value?.color1 : '#1B1B1A', height: '27px', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }} onClick={(e) => { e.stopPropagation(); open('color1'); }} key={'properties.styles.$deviceType.wizardStyle.color1'}>
                </div>
                <div style={{ backgroundColor: value?.color2 ? value?.color2 : '#EDC951', height: '27px' }} onClick={(e) => { e.stopPropagation(); open('color2'); }} key={'properties.styles.$deviceType.wizardStyle.color2'}>
                </div>
                <div style={{ backgroundColor: value?.color3 ? value?.color3 : '#FFFFFF', height: '27px' }} onClick={(e) => { e.stopPropagation(); open('color3'); }} key={'properties.styles.$deviceType.wizardStyle.color3'}>
                </div>
                <div style={{ backgroundColor: value?.color4 ? value?.color4 : '#F2F2F2', height: '27px' }} onClick={(e) => { e.stopPropagation(); open('color4'); }} key={'properties.styles.$deviceType.wizardStyle.color4'}>
                </div>
                <div style={{ backgroundColor: value?.color5 ? value?.color5 : '#494948', height: '27px', borderTopRightRadius: '4px', borderBottomRightRadius: '4px' }} onClick={(e) => { e.stopPropagation(); open('color5'); }} key={'properties.styles.$deviceType.wizardStyle.color5'}>
                </div>
            </div>
        </div>
    )
})